import axios from 'axios';
import { ElMessage } from 'element-plus';

const appData = {
  namespaced: true,
  state: {
    address: [],
    isWeixin: false
  },
  mutations: {
    setAddress: (state, list) => {
      state.address = list;
    }
  },
  actions: {
    getAddress({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.address.length === 0) {
          axios('/files/address.json').then(res => {
            const resData = res.data || [];
            commit('setAddress', resData);
            resolve(resData);
          }).catch(error => {
            console.log(error);
            ElMessage.error(error);
            reject(error);
          });
        } else {
          resolve(state.address);
        }
      });
    }
  }
}

export default appData
